import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Modal, Button } from './'
import { useSelector } from 'react-redux'
import QRCode from 'react-qr-code'
import { isEmpty } from 'lodash'

const useStyles = makeStyles(theme => ({
    modalButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 16
    },
    qrCodeWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 36
    },
    serialTitle: {
        textAlign: 'center',
        marginBottom: 30,
        fontSize: 18
    }
}))

export default function DeviceSerialQrCodeModal({
    open,
    setOpen,
    deviceSerial
}) {
    const classes = useStyles()

    const { locale } = useSelector(state => state.main)

    return (
        <Modal
            open={open}
            setOpen={setOpen}
        >
            <React.Fragment>
                {deviceSerial &&
                    <React.Fragment>
                        <div className={classes.serialTitle}>
                            {locale.devices.serialNr}: {deviceSerial}
                        </div>
                        <div className={classes.qrCodeWrapper}>
                            <QRCode value={deviceSerial} />
                        </div>
                    </React.Fragment>
                }
                {(!deviceSerial || deviceSerial === '' || isEmpty(deviceSerial)) &&
                    <div>
                        {locale.devices.serialEmptyError}
                    </div>
                }
                <div className={classes.modalButtons}>
                    <Button onClick={setOpen.bind(this, false)}>
                        {locale.common.ok}
                    </Button>
                </div>
            </React.Fragment>
        </Modal>
    )
}
